import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import withStyles from '@material-ui/core/styles/withStyles';
// global variables
import { numberOfRowsOptions as NUMBER_OF_ROWS_OPTIONS } from 'config';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import Pagination from 'components/UI/Pagination/Pagination';

/**
 * @description
 * Stateless component.
 *
 * @param {Object} props - Props received from parents.
 */
function Paginator(props) {
  const {
    classes,
    changePage,
    numberOfRowsSelected,
    changeNumberOfRows,
    t,
    nextDisabled,
    prevDisabled,
    queryCount,
  } = props;

  return (
    <GridContainer alignItems="center" justify="flex-end">
      <GridItem data-cy="adListPaginator">
        <Pagination
          pages={[
            {
              text: t('common.pagination.prev').toString(),
              onClick: () => !prevDisabled && changePage('PREVIOUS'),
              id: 'prevButton',
              disabled: prevDisabled,
            },
            {
              text: t('common.pagination.next').toString(),
              onClick: () => !nextDisabled && changePage('NEXT'),
              id: 'nextButton',
              disabled: nextDisabled,
            },
          ]}
          color="info"
        />
      </GridItem>
      <GridItem>
        <FormControl fullWidth className={classes.selectFormControl}>
          <GridContainer alignItems="center">
            <GridItem xs={12}>
              <InputLabel
                htmlFor="simple-select"
                className={classes.selectLabel}
              >
                {t('common.pagination.title')}
              </InputLabel>
              <Select
                data-cy="selectNumberOfRows"
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                value={numberOfRowsSelected}
                onChange={event => changeNumberOfRows(event.target.value)}
                inputProps={{
                  name: 'selected',
                  id: 'select',
                }}
              >
                {NUMBER_OF_ROWS_OPTIONS.map(item => (
                  <MenuItem
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected,
                    }}
                    value={item}
                    key={item}
                  >
                    {t('common.pagination.label')}
                    {item}
                  </MenuItem>
                ))}
              </Select>
              {queryCount && (
                <span style={{ marginLeft: 8 }}>
                  {t('common.pagination.query_count')}
                  <b> {queryCount}</b>
                </span>
              )}
            </GridItem>
          </GridContainer>
        </FormControl>
      </GridItem>
    </GridContainer>
  );
}

/**
 * Paginator PropTypes
 * @param classes - prop styles received from withStyles
 * @param numberOfRowsSelected - prop current number of rows selected
 * @param t - prop from HOC with string translations
 * @param queryCount - show query count
 * @callback changePage - callback to change page buttons
 * @callback changeNumberOfRows - callback to change selected number of rows
 */

Paginator.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  changePage: PropTypes.func.isRequired,
  changeNumberOfRows: PropTypes.func.isRequired,
  numberOfRowsSelected: PropTypes.number.isRequired,
  queryCount: PropTypes.number,
  t: PropTypes.func.isRequired,
  nextDisabled: PropTypes.bool.isRequired,
  prevDisabled: PropTypes.bool.isRequired,
};

Paginator.defaultProps = {
  queryCount: null,
};

export default withTranslation()(withStyles(extendedFormsStyle)(Paginator));
